import * as types from './types';

export const refreshOrder = () => ({
  type: types.REFRESH_ORDER
});
